import { debugLog } from './debug-utils';

// Default selectors
const DEFAULT_IMAGE_SELECTORS = [
  ".card__media .media",
  ".product-image.pr .db .pr_lazy_img.main-img",
  ".product__media__image",
  ".grid-product__image-mask .grid__image-ratio",
  ".card__media .card--image-animate"
];

let cachedConfig = null;

/**
 * Injects custom CSS for this theme into the document head
 */
function injectCustomCss() {
  if (!cachedConfig?.customCss) return;

  const css = cachedConfig.customCss;
  if (!css.trim()) return;

  // Avoid duplicate injection
  if (document.getElementById('pe-disco-theme-custom-css')) return;

  const styleEl = document.createElement('style');
  styleEl.id = 'pe-disco-theme-custom-css';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);
  debugLog(`Injected custom CSS for theme: ${cachedConfig.themeName}`);
}

/**
 * Loads theme config from data script tag.
 * Caches result only if found, so late-arriving configs can still be picked up.
 * @returns {object|null}
 */
function loadThemeConfig() {
  // Return cached config if we've already found one
  if (cachedConfig) return cachedConfig;

  try {
    const scriptTag = document.getElementById('pe-disco-theme-config');
    if (scriptTag) {
      cachedConfig = JSON.parse(scriptTag.textContent);
      debugLog(`Loaded theme-specific config for: ${cachedConfig.themeName}`);

      // Inject custom CSS if present
      injectCustomCss();
    }
  } catch (e) {
    // Parse error - will use fallback selectors
    debugLog(`Failed to parse theme config: ${e.message}`, 'error');
  }

  return cachedConfig;
}

/**
 * Gets theme config from data script tag if available
 * @returns {object|null}
 */
export function getThemeConfig() {
  return loadThemeConfig();
}

/**
 * Gets image container selectors (CSS selector strings for querySelectorAll)
 * @returns {string[]}
 */
export function getImageSelectors() {
  const config = getThemeConfig();
  if (config?.selectors?.productImageContainer) {
    return config.selectors.productImageContainer;
  }
  return DEFAULT_IMAGE_SELECTORS;
}

/**
 * Gets additional navigation classes to skip (bare class names, no dots)
 * @returns {string[]}
 */
export function getAdditionalSkipClasses() {
  const config = getThemeConfig();
  return config?.selectors?.skipClasses || [];
}

/**
 * Gets custom CSS for this theme
 * @returns {string}
 */
export function getCustomCss() {
  const config = getThemeConfig();
  return config?.customCss || '';
}
